<template>
  <div>
    <BaseDialog
      v-model="showDialog"
      dialogIcon="mdi-alert"
      title="Ny reklamasjon"
      btnActionName="Lagre"
      @action="save"
    >
      <template v-slot>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            class="textFieldError"
            v-model="complaint.name"
            color="primary"
            label="Tittel"
            filled
            :rules="[(v) => !!v || 'Tittel må fylles ut!']"
          ></v-text-field>

          <v-textarea
            class="textFieldError"
            v-model="complaint.txt"
            color="primary"
            label="Beskrivelse"
            :rules="[(v) => !!v || 'Beskrivelse må fylles ut!']"
            filled
          ></v-textarea>

          <ContactPersonPicker
            v-model="complaint.contactPersonId"
            :contactId.sync="complaint.contactId"
            label="Ansvarlig"
            prepend-inner-icon="mdi-account-sync"
            :rules="[(v) => !!v || 'Ansvarlig må fylles ut!']"
          />

          <v-btn
            v-if="complaint.attachments && complaint.attachments.length > 0"
            class="mb-2"
            small
            color="primary"
            @click="$refs.dropzone.addAttachment()"
          >
            Legg til fil
          </v-btn>
          <FileDropzone
            ref="dropzone"
            v-model="complaint.attachments"
            :close="false"
          />
        </v-form>
      </template>
    </BaseDialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import notification from "@/helpers/notification";
import ContactPersonPicker from "@/components/shared/field/ContactPersonPicker.vue";
import FileDropzone from "@/components/shared/attachments/FileDropzone.vue";

export default Vue.extend({
  name: "EditProfileDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      valid: true,
      complaint: { attachments: [] },
    };
  },
  watch: {
    value(value: boolean) {
      if (value) {
        this.resetObject();
      }
    },
  },
  methods: {
    save() {
      const isValid = (this as any).$refs.form?.validate();
      if (isValid) {
        this.$emit("save", this.complaint);
      } else {
        notification.warn("Alle obligatoriske felter må fylles ut!");
      }
    },
    resetObject() {
      this.complaint = { attachments: [] };
      (this as any).$refs.form?.reset();
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },

  components: {
    BaseDialog,
    ContactPersonPicker,
    FileDropzone,
  },
});
</script>
